(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('profileHistoryCtrl', ['$scope', '$stateParams', 'profilesHistory', 'profilesService', '$uibModal', function ($scope, $stateParams, profilesHistory, profilesService, $uibModal) {
            
            $scope.profilesHistory = profilesHistory;

            $scope.refresh = function(){
                return profilesService.getHistory($stateParams.pickedApiSpaceId)
                    .then(function (result) {
                        $scope.profilesHistory =  result;
                    }).catch(function (error) {
                        growlService.danger("Couldn't get import history due to:  " + error.statusText);
                    });
            };

            $scope.statuses = {
                inProgress: "In progress",
                failed: "Failed",
                complete: "Complete"
            };
            $scope.getDetails = function (id, type) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'components/toolkit/profiles/templates/importDetailsModal.html',
                    controller: 'importDetailsModal',
                    size: 'lg',
                    resolve: {
                        importDetails: function () {
                            return profilesService.getImportDetails($stateParams.pickedApiSpaceId, id, type);
                        },
                        type: function () {
                            return type;
                        },
                        id: function () {
                            return id;
                        }

                    }
                });

            };
        }]).controller('importDetailsModal', ['$scope', '$stateParams', 'profilesService', 'importDetails', '$uibModalInstance', 'type', 'id',
            function ($scope, $stateParams, profilesService, importDetails, $uibModalInstance, type, id) {


                //$scope.importDetails = importDetails;
                $scope.statuses = [{
                    value: "invalid",
                    label: "Ignored"
                }, {
                    value: "created",
                    label: "Created"
                }, {
                    value: "updated",
                    label: "Updated"
                }];

                $scope.reason = {
                    phoneValidation: "Invalid Number",
                    duplicate: "Duplicate",
                    profileForgotten: "Forgotten Profile"
                };

                $scope.dropdownChanged = function () {
                    return profilesService.getImportDetails($stateParams.pickedApiSpaceId, id, $scope.status)
                        .then(function (importDetails) {
                            mapImportDetails(importDetails);
                        });
                }

                $scope.getStatus = function (status) {
                    var foundStatus = $scope.statuses.find(function (singleStatus) {
                        return singleStatus.value === status;
                    });
                    return foundStatus ? foundStatus.label : status;
                };

                $scope.status = type ? type : $scope.statuses[0].value;

                function mapImportDetails(importDetails) {

                    $scope.importDetails = importDetails.map(function (row) {
                        row.count = row.profileIds ? row.profileIds.length : 0;
                        row.profileIds = row.profileIds ? row.profileIds.join(", ") : "";
                        return row;
                    });
                }

                mapImportDetails(importDetails);

                $scope.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }]);

})(window.angular);